import React, { useState } from 'react';
import { Button, Card, Form, Input, Space, Typography, message } from 'antd';
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './authPages.css';

type SignupFormValues = {
  email: string;
  password: string;
  username: string;
};

export function SignupPage() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const onFinish = async (values: SignupFormValues) => {
    setSubmitting(true);
    try {
      await signup(values);
      // After signup, send user to login.
      navigate('/login', { replace: true });
    } catch (err: any) {
      message.error(err?.response?.data?.message || err?.message || 'Signup failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="authShell">
      <Space direction="vertical" size={16} className="authSpace" style={{ maxWidth: 560, margin: '0 auto' }}>
        <Typography.Title level={2} className="authTitle" style={{ margin: 0 }}>
          Sign up
        </Typography.Title>
        <Typography.Text type="secondary" className="authHelp">
          Create an account to save and track your dictionary entries.
        </Typography.Text>
        <Card className="authCard">
        <Form layout="vertical" onFinish={onFinish} autoComplete="on" requiredMark="optional">
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter your email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="user@example.com" />
          </Form.Item>

          <Form.Item
            name="username"
            label="Username"
            rules={[{ required: true, message: 'Please enter a username' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="johndoe" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="securePassword123" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={submitting}>
              Create account
            </Button>
          </Form.Item>

          <Typography.Text type="secondary">
            Already have an account? <Link to="/login">Log in</Link>
          </Typography.Text>
        </Form>
        </Card>
      </Space>
    </div>
  );
}

